import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/ceneye-botoks-uygulamasi-nedir-nasil-yapilir/page.tsx");
